import { useState, useEffect, createContext, useContext } from 'react';
import { useAuth } from "react-oidc-context";

// initialize the context with an empty object
const UserContext = createContext({});

// list of Jobs that are exceptions i.e. give elevated access to Viewer
// like Tabcmd jobs
// this is hacky and should be controlled elsewhere long term
const exceptions = {
  jobs: [
    'd3c35fda-3f13-4d2d-805f-7f96aed16004'
  ]
}


export default function AuthContext({ children }) {
  // Store the user in a state variable
  const [user, setUser] = useState();
  const auth = useAuth();
  useEffect(() => {
    checkUser();
  }, [auth]);

  const page = window.location.pathname.split('/').slice(1)
  const disabled = (
    auth?.user?.profile?.["role"] !== "Admin" && !(
      exceptions[page?.[0]] || []).includes(page?.[1]
      )
  )

  async function checkUser() {
    try {
      if (auth.isAuthenticated && auth?.user) {
        // set the user in state
        setUser({
          ...auth?.user,
          ...auth?.user?.profile,
          ...{
            role: auth.user.profile?.["role"],
            org: auth.user.profile?.["custom:organization"],
            disabled: disabled
          }
        });
      }
    }
    // Error occurs if there is no user signed in.
    catch (error) {
      // set the user to null if there is no user. 
      setUser(null);
    }
  }
  return (
    <UserContext.Provider
      value={{ ...user }}
    >
      {children}
    </UserContext.Provider>
  );
}

// export the hook so we can use it in other components.
export const useUser = (values) => useContext(UserContext);